<template>
  <div class="app-page-title">
    <Row>
      <h2 class="app-page-title__heading">{{pageTitle}}</h2>
      <Breadcrumb class="app-page-title__breadcrumb" v-if="breadcrumb.length > 1">
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem v-for="(item, index) in breadcrumb" :key="index" :to="item.path || ''">
          {{ item.name }}
        </BreadcrumbItem>
      </Breadcrumb>
    </Row>
  </div>
</template>
<script>
export default {
  name: 'AppPageTitle',
  computed: {
    breadcrumb () {
      return this.$store.getters.breadcrumb
    },
    pageTitle () {
      const bLength = this.breadcrumb.length
      return bLength ? this.breadcrumb[bLength - 1].name : ''
    }
  }
}
</script>
<style lang="less">
  @import '../../assets/less/base/variables.less';
  .app-page-title {
    padding: 16px 24px;
    background: #fff;
    margin: 0 -24px;
    box-shadow: 1px 0 5px rgba(0, 0, 0, 0.1);
    .ivu-row {
      align-items: center;
    }
    &__heading {
      font-size: 20px;
      margin-right: 16px;
      color: @title-color;
    }
    &__breadcrumb {
      font-size: 13px;
      line-height: 1;
      transition: all @animation-time;
      color: @text-color;
      a {
        color: @primary-color;
      }
    }
  }
</style>
